import 'core-js'

import 'regenerator-runtime/runtime'

require('../bootstrap')

import Vue from 'vue'

window.Vue = Vue

import dataStore from './store'

import StatisticsDownload from '../pdf/StatisticsDownload'

import ProjectSlider from './components/ProjectSlider'

import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents);

axios.get('/api/translations/tool/' + document.getElementById('tool-view').dataset.project )

.then(translations => {

    const app = new Vue({

        el : '#tool-view',

        store : dataStore,

        components : {
            ProjectSlider,
            StatisticsDownload
        },

        provide() {
            return {
                language : translations.data
            }
        },


    });

    app.$mount("#tool-view");

})
.catch(err => console.log(err))

Array.prototype.equals = function(array) {
    // if the other array is a falsy value, return
    if (!array) return false;

    // compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
};

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", { enumerable: false });

Object.size = obj => {
    var size = 0,
        key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

String.prototype.reverse = function() {
    return Array.prototype.slice
        .call(this)
        .reverse()
        .join()
        .replace(/,/g, "");
};

String.prototype.replacePlaceholders = function(replacements) {

    // Use a regular expression to find placeholders like ":name"
    const regex = /:([a-zA-Z_]+)/g;

    // Replace each placeholder with the corresponding value from the replacements object
    const replacedString = this.replace(regex, (match, placeholder) => {

        if (replacements.hasOwnProperty(placeholder)) {
            return replacements[placeholder];
        } else {
            return match; // If no replacement is found, keep the placeholder as is
        }

    });

    return replacedString;
};

Element.prototype.hasClass = function(className) {
    return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
};

Vue.directive("display-none", function(el, binding) {
    el.style.display = !!binding.value ? "block" : "none";
});

